/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Main Entry Point
 */
import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import { ProConfigProvider } from '@ant-design/pro-components';
import en_US from 'antd/es/locale/en_US';
import { DEFAULT_ICON_CONFIGS, IconProvider } from '@icon-park/react';

import ViewPortBlocker from 'components/app/widgets/ViewPortBlocker';
import ReleasePrompt from 'components/app/widgets/ReleasePrompt';
import { ROUTES } from 'configs/routes';
import { theme } from 'styles/theme';
import 'styles/index';

const SecureApp = lazy(() => import('components/app/index'));
const Logout = lazy(() => import('components/app/widgets/Logout'));

const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path={ROUTES.logout.landing} element={<Logout />} />
			<Route path={ROUTES.home.match} element={<SecureApp />} />
		</>,
	),
);

/**
 * App Component
 * @returns {React.FC} App
 */
const App = () => {
	return (
		// TODO - add strict mode
		// TODO - add release prompt
		<ViewPortBlocker>
			<ProConfigProvider hashed={false}>
				<ConfigProvider locale={en_US} theme={theme} wave={{ disabled: true }} modal={{ centered: true }}>
					<AntdApp
						message={{ top: 60, duration: 3, maxCount: 1 }}
						notification={{ maxCount: 3, placement: 'bottomRight', duration: 12, bottom: 70 }}
					>
						<IconProvider value={{ ...DEFAULT_ICON_CONFIGS, size: 14, strokeWidth: 4, prefix: 'anticon anticon' }}>
							<RouterProvider router={router} />
							<ReleasePrompt />
						</IconProvider>
					</AntdApp>
				</ConfigProvider>
			</ProConfigProvider>
		</ViewPortBlocker>
	);
};

const container = document.getElementById('root') ?? document.body;
const root = createRoot(container);
root.render(<App />);
